export default __webpack_public_path__ + "content/media/5.5fbe8d17.jpg";